class InterceptorAuth {
	constructor($injector) {
		this.$injector = $injector;
		this.$rootScope = $injector.get('$rootScope');
		this.$cookies = $injector.get('$cookies');
		this.AUTH_KEYS = $injector.get('AUTH_KEYS');
		this.AUTH_EVENTS = $injector.get('AUTH_EVENTS');
		this.PUBLIC_KEY = $injector.get('PUBLIC_KEY');
		this.API = $injector.get('API');

		this.$q = $injector.get('$q');
		this.bufferLength = 0;
		//
		this.request = this.requestFn.bind(this);
		this.response = this.responseFn.bind(this);
		this.responseError = this.responseErrorFn.bind(this);
	}

	requestFn(config) {
		config.headers = config.headers || {};
		const userToken = this.$cookies.get(this.AUTH_KEYS.tokenKey);

		// do not add Auth when calling googleapis or c4c easy-link
		// const thirdParty = /^https:\/\/maps\.googleapis\.com.*/.test(config.url) || /easy-link/.test(config.url);
		// Only attach the token to actual API calls. Static assets (svg, img, fonts, etc.)
		// may be served from the same host as a local API and must not carry the Auth header.
		const isOcaApi = config.url.includes(this.API);
		const isStaticAsset = /\.(svg|png|jpe?g|gif|webp|ico|woff2?|ttf|eot|css|map)(\?.*)?$/i.test(config.url);
		if (!config.headers?.Auth && isOcaApi && !isStaticAsset) config.headers.Auth = userToken;

		if (config.headers?.['Content-Type'] && !config?.data) {
			config.data = '';
		}

		return config;
	}

	/**
	 * Handles the response interceptor for authentication
	 * Auth0 owns token issuance, so responses are passed through untouched.
	 * TODO: if needed, session_token should not be returned, ask API
	 * @param {Object} response - The response object from the HTTP request
	 * @returns {Object} The processed response object
	 */
	responseFn(response) {
		return response;
	}

	/**
	 * Handles authentication errors in the response
	 * @param {Object} rejection - The rejection object containing error details
	 * @returns {Promise} A promise that either buffers the request or rejects with the error
	 */
	responseErrorFn(rejection) {
		const HttpBuffer = this.$injector.get('HttpBuffer');
		const config = rejection.config || {};
		if (rejection.status == 401 || rejection.status == 403) {
			if (this.AUTH_KEYS.bufferReq) {
				const _dfr = this.$q.defer();
				this.bufferLength = HttpBuffer.append(config, _dfr);
				if (this.bufferLength === 1) this.$rootScope.$broadcast(this.AUTH_EVENTS.BUFFER_LOGIN, rejection);
				return _dfr.promise;
			} else {
				this.$rootScope.$broadcast(this.AUTH_EVENTS.LOGIN, rejection);
			}
		}

		return this.$q.reject(rejection);
	}

	static create($injector) {
		return new InterceptorAuth($injector);
	}
}
//
InterceptorAuth.create.$inject = ['$injector'];
export default InterceptorAuth;
